// The `PrepRecipes` key and the `prepRecipes` id are kept as-is on purpose:
// they are in saved URLs and query keys. Only the label changed, because the
// tab now holds plated recipes too (T-701). Menu items are managed from the
// Menus module, so they are no longer a tab here (YC-6).
export const TabTitle = {
  PrepRecipes: "Recipes",
  Ingredients: "Ingredients",
} as const;

export type TabKey = keyof typeof TabTitle;
export type SectionTitle = (typeof TabTitle)[TabKey];
export type SectionTitleMap = { [K in TabKey]: typeof TabTitle[K] };
export type SectionTitleFor<K extends TabKey> = SectionTitleMap[K];

export const ACTIVE_TABS_IDS = ["prepRecipes", "ingredients"] as const;

export type ActiveTabsIds = (typeof ACTIVE_TABS_IDS)[number];

/** Where Recipes lands with no tab, and where a retired tab value (e.g. an old `menuItems` link) falls back to. */
export const DEFAULT_RECIPES_TAB: ActiveTabsIds = "prepRecipes";

// Mapping from id → title-key
export type IdToTitleKey = {
  prepRecipes: "PrepRecipes";
  ingredients: "Ingredients";
};